import * as types from './types'

export default {
  [types.SERIES_TYPES]: state => {
    return state.types
  },
  [types.SERIES_REPETITION_TYPES]: state => {
    return state.repetitionsTypes
  },
  [types.SERIES_MONTHLY_REPETITION_TYPES]: state => {
    return state.monthlyRepetitionTypes
  },
  [types.DUTY_VALUE_SOURCE_TYPES]: state => {
    return state.dutyValueSources
  },
  [types.SERIES_SEARCH_RESULTS]: state => {
    return state.searchResults
  },
}
